import { Card, Col, Row, theme, Typography } from "antd";
import { useNavigate } from "react-router-dom";

export default function MobileCardsList({
  dataSource,
  columns,
  rowKey,
  smTitle,
  onRowLink,
}) {
  const navigate = useNavigate();
  const {
    token: { colorTextBase },
  } = theme.useToken();
  const mainTitle = ({ item }) => {
    let maintitleDeclared = columns.find(e => e.smMainTitle === true);

    if (maintitleDeclared !== undefined) {
      return maintitleDeclared.render(item[maintitleDeclared.dataIndex]);
    } else {
      return "Main title";
    }
  };

  const renderItemText = (col, item) => {
    const text = item[col.dataIndex];

    if (col.render !== undefined) {
      return col.render(text, item);
    } else {
      return text;
    }
  };

  return dataSource.map(item => {
    return (
      <Card
        title={
          <div
            onClick={() => navigate(onRowLink(item))}
            style={{ cursor: "pointer" }}
          >
            {smTitle(item)}
          </div>
        }
        style={{ margin: "0 0 10px 0" }}
        key={item[rowKey]}
      >
        <Row gutter={[5, 5]}>
          {columns
            .filter(e => e?.sm !== false)
            .map(col => {
              return (
                <>
                  <Col key={"title" + col.key + item[rowKey]} span={6}>
                    {col.smTitle || col.title}
                  </Col>
                  <Col key={"value" + col.key + item[rowKey]} span={18}>
                    <span style={{ fontWeight: 500, color: colorTextBase }}>
                      {renderItemText(col, item)}
                    </span>
                  </Col>
                </>
              );
            })}
        </Row>
      </Card>
    );
  });
}
